/**
 * Warenkorb-Empfehlungen auf der Warenkorb-SEITE (/cart) aktuell halten.
 *
 * Warum es das braucht: Das Theme rendert bei Warenkorb-Aenderungen nur die
 * Sections neu, die sich ueber `cart:grouped-sections` selbst anmelden - das
 * sind die `cart-items-component`-Flaechen. Unser Abschnitt ist eine eigene
 * Section und wuerde sonst stehen bleiben. Wird der teuerste Artikel entfernt,
 * zeigte er weiter die Empfehlungen zum alten Bezugsartikel.
 *
 * Warum es NICHT den Bezugsartikel im Browser ausrechnet: Dann gaebe es die
 * Regel "hoechster Stueckpreis" zweimal - einmal in Liquid, einmal hier - und
 * sie wuerden frueher oder spaeter auseinanderlaufen. Stattdessen wird der
 * Abschnitt schlicht neu vom Server geholt; die Regel bleibt an genau einer
 * Stelle.
 *
 * Im Warenkorb-Fenster (Drawer) macht das weiterhin das Theme selbst - dort
 * ist der Abschnitt Teil der cart-drawer-Section.
 */

const WARTEZEIT = 150;
let zeitgeber = null;
let laeuft = false;

async function abschnittNeuHolen(el) {
  const sid = el.dataset.lbrgtSectionId;
  if (!sid || laeuft) return;
  laeuft = true;
  try {
    const url = `${window.location.pathname.split('?')[0]}?section_id=${encodeURIComponent(sid)}`;
    const res = await fetch(url);
    if (!res.ok) return; // still lassen: lieber der alte Stand als ein kaputter
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const neu = doc.querySelector('[data-lbrgt-cart-section]');
    if (neu) el.innerHTML = neu.innerHTML;
  } catch {
    // Netzfehler: der bestehende Abschnitt bleibt stehen.
  } finally {
    laeuft = false;
  }
}

function angestossen() {
  clearTimeout(zeitgeber);
  zeitgeber = setTimeout(() => {
    document.querySelectorAll('[data-lbrgt-cart-section]').forEach((el) => abschnittNeuHolen(el));
  }, WARTEZEIT);
}

// `cart:update` feuert das Theme nach jeder Mengen- oder Loeschaktion.
document.addEventListener('cart:update', angestossen);
document.addEventListener('cart:updated', angestossen);
